module.exports = __webpack_public_path__ + "static/media/savvy-ipfs-desktop.b584c4ca.svg";